import { chatKindOf } from '@bt-common/schemas/wa/chat-kind';
import BTInputField from "@common-components/bt-input-field/bt-input-field";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { getWhatsappContactsFilterd, setContactFilterName } from "@common-reducers/WhatsAppViewReducer";
import { privateSetCurrentChat } from "@common-reducers/WhatsAppReducer";
import { getWaChatContactDisplayName } from "@/common/utils/display-name-utils";
import { WaContact } from "@common/models/waContact";
import { postMessageWithResponse } from '@common/services/post-message-to-whatsapp-functions';
import { Virtuoso } from "react-virtuoso";
import WhatsappContactBox from "./whatsapp-contact-box";

const WhatsappContactList = () => {
  const dispatch = useAppDispatch();

  const whatsappContactsFilterd = useAppSelector(getWhatsappContactsFilterd);

  function filterBoards({ target }: any) {
    dispatch(setContactFilterName(target.value));
  }

  const focusWAContact = async (user: WaContact) => {
    const contactId = user.id?._serialized || user._serialized;
    if (contactId) {
      // Create a Chat object from WaContact data
      const displayName = getWaChatContactDisplayName(user, { fallback: contactId });
      const chat = {
        id: user.id ? user.id : { _serialized: contactId }, // Preserve original id object if it exists
        name: displayName,
        displayName: displayName,
        contact: user,
        checked: false,
        isGroup: chatKindOf(contactId) === 'group',
        attachMediaContents: { _models: [] } as any, // Required field
        canSend: true,
        unreadCount: 0,
        formattedTitle: displayName,
      } as any; // Cast to any to avoid strict type checking for this use case

      // Update local Redux state immediately
      dispatch(privateSetCurrentChat(chat));

      // Also send message to extension (for extension context communication)
      try {
        await postMessageWithResponse({
          cmd: "currentChat",
          data: {
            id: { _serialized: contactId }
          }
        });
      } catch (error) {
        console.error("Failed to set current chat:", error);
      }
    }
  };

  return (
    <div>
      <BTInputField
        type="text"
        onChange={filterBoards}
        placeholder={"Search contacts..."}
      />

      <Virtuoso
        style={{ height: '400px' }}
        totalCount={whatsappContactsFilterd.length}
        itemContent={index => {
          const whatsappUser = whatsappContactsFilterd[index]

          if (!whatsappUser) {
            return <div>Loading...</div>;
          }

          const contactName = getWaChatContactDisplayName(whatsappUser);

          return (
            <div key={`contact${index}`} onClick={(e) => focusWAContact(whatsappUser)}
              style={{ marginBottom: "10px", cursor: "pointer" }} >
              <WhatsappContactBox
                contactName={contactName}
                whatsappId={whatsappUser.id?._serialized || whatsappUser._serialized}
                showMessageDetails={true}
                message=""
              />
            </div >
          )
        }}
      />
    </div>
  );
};

export default WhatsappContactList;
